export default "b620e3aa47fd0114.svg"